import { PreOrder } from './ProductListCollections/Collection/PreOrder';
import { Wishlist } from './ProductListCollections/Collection/Wishlist';
import Total from './Total';
import { SmCart } from './SmCart';

export class Cart {
  /**
   * @type {Map<string, BaseCollection>}
   */
  #map = new Map();

  /**
   * @type {Total}
   */
  total;

  /**
   * @type {SmCart}
   */
  smCart;

  storage;

  constructor() {
    this.smCart = new SmCart();
    this.smCartListen();
    this.total = new Total(this.smCart);
    this.#map.set('PreOrder', new PreOrder(this.total));
    this.#map.set('Wishlist', new Wishlist(this.total));
  }

  /**
   * Set classname cart list element to generate first data
   * @param {string} className
   * @returns {Cart}
   */
  setProductsClassName(className) {
    this.#map.get('PreOrder').getProductList(className);
    this.#map.get('Wishlist').getProductList(className);
    return this;
  }

  /**
   * @returns {Product[]}
   */
  getAllProducts() {
    return [...new Set([...this.#map.get('PreOrder').products, ...this.#map.get('Wishlist').products])];
  }

  /**
   * @returns {[{ product_id: number, count: number, check: boolean }]}
   */
  getShortAllProducts() {
    const filtered = [];
    Array.prototype.filter.call(this.getAllProducts(), (product) => {
      filtered.push({
        product_id: product.id,
        count: product.count,
        check: product.wish,
      });
    });
    return filtered;
  }

  /**
   * @returns {number}
   */
  getAllProductsCount() {
    const products = this.getAllProducts();
    return Object.keys(products)
      .reduce((acc, current) => acc + products[current].count, 0);
  }

  smCartListen() {
    document.querySelector('[data-total-sum]')?.addEventListener('Total:update', async () => {
      this.smCart.update(this.getAllProductsCount());
    });
    return this;
  }

  /**
   * Remove all products from cart
   * @returns {Cart}
   */
  async clear() {
    this.#map.get('PreOrder').products = [];
    this.#map.get('Wishlist').products = [];
    this.total.Count = 0;
    this.total.Sum = 0;
    this.total.Price = 0;
    this.smCart.update(0);
    this.total.updateSummary();
    return this;
  }

  /**
   * @returns {Map<string, BaseCollection>}
   */
  get map() {
    return this.#map;
  }
}
